// 开启 HMR 支持
import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import AppWeb from '@/AppWeb.tsx';

ReactDOM.render(<AppWeb />, document.getElementById('root'));
